export const BASE_CLASS = 'mt-ListModelDetails'
export const WITH_WRAPPER_CLASS = 'with-wrapper'
export const PADDINGLESS_CLASS = `${BASE_CLASS}--paddingless`

export const LIST_TYPES = {
  accordion: 'accordion',
  basic: 'basic',
  icon: 'icon'
}
